<template>
  <div class="iv-dealt">
    <section class="iv-main-width iv-p-t-40">
      <SearchLayout :spreadType="2" :list="searchList" @on-search="onSearch"></SearchLayout>
      <p class="iv-heng"></p>
      <ul v-if="show">
        <li  class="iv-dealt-list iv-m-t-40" v-for="(todo, i) in todoList" :key="i">
          <span class="iv-dealt-state">
            <img src="~@/assets/images/begin.png" />
          </span>
          <span class="iv-fs-14 " style="float: right; marginRight:25px;marginTop:10px;color: rgba(0, 0, 0, 0.45);">
            编号：{{todo.itemNumber}}
          </span>
          <Row class="iv-todo-list-content">
            <Col span="7" class="iv-m-t-16">
              <dl>
                <dd class="iv-pull-left iv-fs-14">
                  <p class="iv-fc-85 iv-fw-5">{{todo.todoName}}</p>
                  <p class="iv-fc-45 iv-m-t-4">待办名称</p>
                </dd>
              </dl>
            </Col>
            <Col span="3" class="iv-fs-14 iv-m-t-16">
              <p class="iv-fc-85">{{todo.todoGroup}}</p>
              <p class="iv-m-t-4 iv-fc-45 iv-fw-4">待办分组</p>
            </Col>
            <Col span="12" class="iv-fs-14 iv-m-t-16">
              <ol>
                <li v-for="(chart, i) in todo.colums"
                  :key="i"
                  class="iv-top"
                  >
                  <Poptip trigger="hover" :title="chart.label" :content="chart.value" placement="top-start">
                  <p :class="chart.col === 1 ? 'iv-todo-chart-full' : 'iv-todo-chart'">
                    <span class="iv-fc-45">{{chart.label}}：</span>
                    <span >{{chart.value}}</span>
                  </p>
                </Poptip>
                </li>
              </ol>
            </Col>
            <Col span="2" class="iv-m-t-16">
              <Row class="iv-todo-opt iv-p-l-16">
                <Col span="10" class="iv-pointer" style="float:right" v-for="(opt, i) in todo.optBtList" :key="i">
                  <span @click="onHandle(todo.itemId)">{{opt.label}}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <div class="iv-todo-bottom-info iv-p-l-20 iv-p-t-8 iv-p-b-8">
            <Row class="iv-fs-14">
              <Col span="8">
                <span class="iv-fc-45">交办人：</span>
                <span class="iv-fc-65 iv-p-r-24">{{todo.assigned || '张三'}}</span>
                <span class="iv-fc-45 iv-p-l-24">交办时间：</span>
                <span class="iv-fc-65">{{timeFormat(todo.assignedDate, 'yyyy-MM-dd HH:mm:ss')}}</span>
              </Col>
              <Col span="8">
                <span class="iv-fc-45">待办人：</span>
                <span class="iv-fc-65">{{todo.todoUser}}</span>
              </Col>
              <Col span="8">
                <div>
                  <span class="iv-fc-45">办理人：</span>
                  <span class="iv-fc-65 iv-p-r-24">{{todo.handlerUser}}</span>
                  <span class="iv-fc-45 iv-p-l-24">办理时间：</span>
                  <span class="iv-fc-65">{{timeFormat(todo.handlerDate, 'yyyy-MM-dd HH:mm:ss')}}</span>
                </div>
              </Col>
            </Row>
          </div>
        </li>
      </ul>
      <NoData v-else message="暂无待办事项"></NoData>
    </section>
    <Page v-if="total > 0 && show" :total="total"  
      :current="currentPage"
      :pageSize="pageSize"
      @on-change="onPageChange"
      @on-page-size-change="onPageSizeChange" class="iv-main-width iv-m-t-40"></Page>
  </div>
</template>

<script>
import FormLayout from '@/components/layout/form'
import {timeFormat, getToken} from '@/utils'
import searchList from './searchList'
import Page from '@/components/page'
import NoData from '@/components/no-data'
import IconFont from '@/components/iconfont'
import SearchLayout from '@/components/search-layout'

export default {
  name: 'dealtList',
  data () {
    return {
      personInfo: {},
      show: true,
      total: 0,
      rules: [],
      todoList: [],
      listParams: {},
      currentPage: 1,
      pageSize: 5
    }
  },
  created () {
    this.setSearchList([], '1')
    this.onSearch ({})
  },
  methods: {
    getTodoCount () {
      this.$ajax({
        url: '/api-uum/todo/getTodoCount',
        method: 'get',
      }).then((data) => {
        this.showCount = data.data.data.showCount
      })
    },
    // 获取待办
    getTodoMyList (data) {
      this.$ajax({
        url: '/api-uum/todo/getMyTodoList',
        method: 'get',
        data:{
          ...data
        }
      }).then((res) => {
        if (res.data.data && res.data.data.length) {
          this.show = true
          this.todoList = res.data.data.filter(item => {
            return item.state == 2
          })
          this.currentPage = res.data.currentPage
          this.total = res.data.count
          this.getTodoCount()
          return
        }
        this.show = false
      })
    },
    handleSubmit () {
    },
    timeFormat,
    //点击处理按钮
    onHandle (itemId) {
      this.toForwardTodoPage(itemId)
    },
    toForwardTodoPage (itemId) {
      const orgId = sessionStorage.getItem('listOrgId')
      let url = `/api-uum/todo/forwardTodoPage?itemId=${itemId}&access_token=${getToken()}&currentAuthScopeId=${orgId}`
      window.open(url)
    },
    //搜索
    onSearch (params, type) {
      if (!type) {
        this.currentPage = 1
        this.pageSize = 5
      }
      if (Object.keys(params).length) {
        this.currentPage = 1
      }
      if (type == 'reset') {
        this.currentPage = 1
        this.pageSize = 5
        this.listParams = {}
      }
      this.listParams = Object.assign(this.listParams, params, {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        state: 2
      })
      this.getTodoMyList(this.listParams)
    },
    //设置搜索字段
    setSearchList (group, type) {
      this.searchList = searchList.call(this)
    },
    onPageChange(data){
      this.currentPage = data
      this.onSearch({}, '1')
    },
    onPageSizeChange(data){
      this.pageSize = data
      this.onSearch({}, '1')
    },
  },
  components: {
    Page,
    NoData,
    IconFont,
    SearchLayout,
    FormLayout
  }
}
</script>

<style lang="scss" scoped>
.iv-dealt {
  height: 100%;;
  background-color: #fff;
  .iv-dealt-title {
    position: relative;
    &::before {
      content: "";
      width: 6px;
      height: 24px;
      background: #FA2900;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -12px;
      border-radius: 3px;
    }
  }
  .iv-dealt-list {
    position: relative;
    border-radius:4px;
    border:1px solid rgba(0,0,0,0.15);
    .iv-dealt-state {
      position: absolute;
      left: -2px;
      top: 8px;
    }
    .iv-todo-list-content {
      // height: 143px;
      padding: 38px 20px 23px 20px;
      .iv-todo-list-icon {
        width: 48px;
        height: 48px;
        line-height: 48px;
        background: #009AD8;
        border-radius: 4px;
        color: #fff;
        .iconfont {
          font-size: 32px;
        }
      }
      .iv-todo-opt {
        height: 42px;
        line-height: 42px;
        span {
          // color: #FA2900;
          // color: #009AD8;
          font-size: 14px;
        }
      }
    }
    .iv-todo-bottom-info {
      border-top: 1px solid rgba(0,0,0,0.15);
    }
  }
}
.iv-toubu {
  display: flex;
  width: 1200px;
  flex-wrap: wrap;
  // justify-content: space-around;
}
.iv-form {
  width: 400px;
  display: inline-block;
  justify-content: space-between;
}
.iv-form-kuang {
  width: 302px !important;
  height: 40px;
  border-radius: 8px;
}
/deep/ .ivu-input {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
/deep/ .ivu-select-placeholder {
  height: 40px !important;
  line-height: 40px !important;
}
/deep/ .ivu-select-selection {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 40px;
}
/deep/ .ivu-select-arrow {
  margin-top: -5px;
}
/deep/ .ivu-form-item-label {
  color: rgba($color: #000000, $alpha: 0.65);
  font-size: 14px;
}
.iv-botton {
  float: right;
  // margin-top: 10px;
  width: 400px;
}
.iv-tijiao {
  border-radius: 8px;
  width: 88px;
  height: 40px;
  margin-left: 116px;
}
.iv-cancel {
  border-radius: 8px;
  width: 88px;
  height: 40px;
}
.iv-heng {
  height: 1px;
  background: rgba(0, 0, 0, 0.15);
  // border: 1px solid rgba(0, 0, 0, 0.15);
  margin: 20px 0;
}
/deep/.iv-top {
  margin-bottom: 5px;
}
</style>
